import buffer from 'buffer'
export const columns = (vm) =>{
    return [
        {
            type: 'index',
            width: 50,
            label: '序号'
        },
        {
            label:'缩略图',
            prop:'name',
            align:'center',
            headerAlign:'center',
            tooltip:true,
            render:(h,param)=>{;
                return h('div',{
                    style:{
                        display: 'flex',
                        alignItem: 'center',
                        justifyContent:'center'
                    }
                },param.row.resourceUrl?[
                    h('img',{attr:{ src: param.row.resourcesUrl,
                        width: '32',
                        height: '32',}})
                ]:'--')
            }
        },
        {
            label:'广告名称',
            prop:'title',
            align:'center',
            headerAlign:'center',
            width:130,
            tooltip:true
        },
        {
            label:'尺寸L*W（px）',
            prop:'name',
            align:'center',
            headerAlign:'center',
            width:260,
            render:(h,param)=>{
                let width = param.row.width;
                let height = param.row.height;
                return h('div',{},`${width} * ${height}`)
            }
        },
        {
            label:'URL',
            align:'center',
            headerAlign:'center',
            prop:'linkUrl',
            width:300
        },
        {
            label:'排序',
            tooltip:true,
            prop:'priority',
            align:'center',
            headerAlign:'center'

        },
        {
            label:'最近操作人',
            align:'center',
            headerAlign:'center',
            prop:'operator',
            tooltip:true
        },
        {
            label:'最近操作时间',
            width:160,
            prop:'updateTime',
            align:"center",
            headerAlign:"center"
        },
        {
            label:'操作',
            width:120,
            align:"center",
            headerAlign:"center",
            render: (h, params) => {
                let edit = (h)=>{
                    return h('el-link',{
                        props:{
                            type:'primary',
                            underline:false
                        },
                        style:{
                            'margin-right':'10px'
                        },
                        on:{
                            click:()=>{vm.operateShow(1,params.row)}
                        }
                    },'编辑')
                }

                let del = (h)=>{
                    return h('el-link',{
                        props:{
                            type:'primary',
                            underline:false
                        },
                        on:{
                            click:()=>{vm.operateShow(2,params.row)}
                        }
                    },'删除')
                }

                let btnArr = [];
                btnArr.push(edit(h));
                // if(vm.banner.bannInfo.length != 0)
                console.log('b',vm.banner.bannerInfo)
                    btnArr.push(del(h));

                return h('div',{},btnArr)
            }
        }
    ]
}